import { animate, state, style, transition, trigger } from '@angular/animations';

// Custom Animations made for specific components and features in the application
export const rotateChevronOnCollapseAnimation = trigger('rotateChevron', [
    state('collapsed', style({ transform: 'rotate(90deg)' })),
    state('expanded', style({ transform: 'rotate(0deg)' })),
    transition('collapsed <=> expanded', [animate('100ms ease-in-out')]),
]);

export const fadeInOnEnterAnimation = trigger('fadeInOnEnter', [
    state('*', style({ opacity: 1 })),
    transition('void => *', [style({ opacity: 0 }), animate(250, style({ opacity: 1 }))]),
    transition('* => void', [animate(250, style({ opacity: 0 }))]),
]);
export const fadeInOutAnimation = trigger('fadeInOut', [
    state('true', style({ opacity: 1 })),
    state('false', style({ opacity: 0 })),
    transition('true <=> false', animate('500ms ease-in-out')),
]);
export const fadeInOutVoid = [
    trigger('fadeInOutVoid', [
        state(
            'void',
            style({
                opacity: 0,
            })
        ),
        transition('void <=> *', animate('300ms')),
    ]),
];
export const fadeInOutSlow = trigger('fadeInOutSlow', [
    state('true', style({ opacity: 1 })),
    state('false', style({ opacity: 0 })),
    transition('true <=> false', animate('1000ms ease-in-out')),
]);

export const slideFromRightAnimation = trigger('slideFromRight', [
    state('true', style({ opacity: 1, transform: 'translateX(0)' })), // slide in from right
    state('false', style({ opacity: 0, transform: 'translateX(100%)' })), // slide out to right
    transition('true <=> false', animate('1000ms ease-in-out')),
]);
export const slideFromLeftAnimation = trigger('slideFromLeft', [
    state('true', style({ opacity: 1, transform: 'translateX(0)' })), // slide in from left
    state('false', style({ opacity: 0, transform: 'translateX(-100%)' })), // slide out to left
    transition('true <=> false', animate('1000ms ease-in-out')),
]);
export const slideUpAndDownAnimation = trigger('slideUpAndDown', [
    state('up', style({ transform: 'translateY(0)' })),
    state('down', style({ transform: 'translateY(200%)' })),
    transition('void => up', [style({ transform: 'translateY(200%)' }), animate('200ms ease-in')]),
    transition('void => down', [style({ transform: 'translateY(0%)' }), animate('200ms ease-out')]),
    transition('up => down', [style({ transform: 'translateY(0)' }), animate('200ms ease-out')]),
    transition('down => up', [style({ transform: 'translateY(200%)' }), animate('200ms ease-in')]),
]);

export const slideWizardUpDownAnimation = trigger('slideWizardUpDown', [
    state('hidden', style({ transform: 'translateY(100%)' })),
    state('visible', style({ transform: 'translateY(0)' })),
    transition('hidden => visible', animate('500ms ease-out')),
    transition('visible => hidden', animate('500ms ease-in')),
]);

// Default animations

// Slide Animations
export const slideInLeftAnimation = trigger('slideInLeft', [
    transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0)' })),
    ]),
]);
export const slideInRightAnimation = trigger('slideInRight', [
    transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0)' })),
    ]),
]);
export const slideOutLeftAnimation = trigger('slideOutLeft', [
    transition('* => void', [animate('300ms ease-out', style({ transform: 'translateX(-100%)' }))]),
]);
export const slideOutRightAnimation = trigger('slideOutRight', [
    transition('* => void', [animate('300ms ease-out', style({ transform: 'translateX(100%)' }))]),
]);
export const slideUpAnimation = trigger('slideUp', [
    transition('void => *', [
        style({ transform: 'translateY(100%)' }),
        animate('300ms ease-in', style({ transform: 'translateY(0)' })),
    ]),
]);
export const slideDownAnimation = trigger('slideDown', [
    transition('void => *', [
        style({ transform: 'translateY(-100%)' }),
        animate('300ms ease-in', style({ transform: 'translateY(0)' })),
    ]),
]);

// Fade Animations
export const fadeInAnimation = trigger('fadeIn', [
    transition('void => *', [style({ opacity: 0 }), animate('150ms', style({ opacity: 1 }))]),
]);
export const fadeInLeftAnimation = trigger('fadeInLeft', [
    transition('void => *', [
        style({ opacity: 0, transform: 'translateX(-100%)' }),
        animate(
            '300ms',
            style({
                opacity: 1,
                transform: 'translateX(0)',
            })
        ),
    ]),
]);
export const fadeInRightAnimation = trigger('fadeInRight', [
    transition('void => *', [
        style({ opacity: 0, transform: 'translateX(100%)' }),
        animate(
            '300ms',
            style({
                opacity: 1,
                transform: 'translateX(0)',
            })
        ),
    ]),
]);
export const fadeOutAnimation = trigger('fadeOut', [
    transition('* => void', [animate('300ms', style({ opacity: 0 }))]),
]);
export const fadeOutQuickAnimation = trigger('fadeOutQuick', [
    transition('* => void', [animate('100ms', style({ opacity: 0 }))]),
]);
export const fadeOutLeftAnimation = trigger('fadeOutLeft', [
    transition('* => void', [
        animate(
            '300ms',
            style({
                opacity: 0,
                transform: 'translateX(-100%)',
            })
        ),
    ]),
]);
export const fadeOutRightAnimation = trigger('fadeOutRight', [
    transition('* => void', [
        animate(
            '300ms',
            style({
                opacity: 0,
                transform: 'translateX(100%)',
            })
        ),
    ]),
]);
export const fadeUpAnimation = trigger('fadeUp', [
    transition('void => *', [
        style({ opacity: 0, transform: 'translateY(100%)' }),
        animate(
            '300ms',
            style({
                opacity: 1,
                transform: 'translateY(0)',
            })
        ),
    ]),
]);
export const fadeDownAnimation = trigger('fadeDown', [
    transition('void => *', [
        style({ opacity: 0, transform: 'translateY(-100%)' }),
        animate(
            '300ms',
            style({
                opacity: 1,
                transform: 'translateY(0)',
            })
        ),
    ]),
]);

export const slideAnimations = [
    slideInLeftAnimation,
    slideInRightAnimation,
    slideOutLeftAnimation,
    slideOutRightAnimation,
    slideUpAnimation,
    slideDownAnimation,
];
export const fadeAnimations = [
    fadeInAnimation,
    fadeInLeftAnimation,
    fadeInRightAnimation,
    fadeOutAnimation,
    fadeOutQuickAnimation,
    fadeOutLeftAnimation,
    fadeOutRightAnimation,
    fadeUpAnimation,
    fadeDownAnimation,
];
export const customAnimations = [
    fadeInOnEnterAnimation,
    fadeInOutAnimation,
    ...fadeInOutVoid,
    slideFromRightAnimation,
    slideFromLeftAnimation,
    slideUpAndDownAnimation,
    rotateChevronOnCollapseAnimation,
];

// Export all animations as an array
export const CeAnimations = [...customAnimations, ...fadeAnimations, ...slideAnimations];
